import authAxios from "../utils/authAxios";

const deckClient = {
    getAllDecks: async () => {
        return await authAxios(`/api/decks`, {
            method: 'GET',
        });
    },

    getDeckById: async (deckId) => {
        return await authAxios(`/api/decks/${deckId}`, {
            method: 'GET',
        });
    },

    createDeck: async (deck) => {
        return await authAxios(`/api/decks`, {
            method: 'POST',
            data: deck,
        });
    },

    updateDeck: async (deckId, deck) => {
        return await authAxios(`/api/decks/${deckId}`, {
            method: 'PUT',
            data: deck,
        });
    },

    deleteDeck: async (deckId) => {
        return await authAxios(`/api/decks/${deckId}`, {
            method: 'DELETE',
        });
    },
};

export default deckClient;
